import { Absolute } from "./Absolute";
import { Base } from "./Base";
import { Page } from "./Page";

export const Loading = {
  Base,
  Page,
  Absolute,
};
